import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const NoteSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default NoteSVG;
